import React, {useEffect } from 'react'
import {Link} from 'react-router-dom'
import AnimationContainer from '../components/AnimationContainer'

const animationDelay = 0.2 * (window.innerWidth > 768 ? 1 : 0)


function ChromeExtensions() {
  useEffect(()=>{
    console.log(window.scrollY)
    window.scrollTo(0, 0)
  },[])

  return (
    <>
      {/* <svg className='rocketSVG' style={{ transform: 'rotate(90deg)', zIndex: 0 }} viewBox="0 0 200 200" width={200} height={200}><g fill="rgba(255,255,255,0.9)"><path d="M100 20 C118 40 126 72 126 108 L146 136 L128 132 L120 166 L100 146 L80 166 L72 132 L54 136 L74 108 C74 72 82 40 100 20 Z"/><path d="M74 104 L34 126 L60 132 L78 118 Z"/><path d="M126 104 L166 126 L140 132 L122 118 Z"/><ellipse cx={100} cy={64} rx={10} ry={16}/><rect x={92} y={146} width={16} height={24} rx={3}/></g></svg> */}
      <main className='contentContainer ChromeExtensionsPage' style={{overflow: "hidden", padding: "60px 40px", position: "relative"}}>
        <div className='contentContainer'>
          <h1 className='chromeExtensions__header' data-aos="fade-down">ChromeExtensions</h1>
          <div className="chromeExtensions__container" data-aos="fade-right">
            <div className="chromeExtensions__divider">
              <div className="chromeExtensions__divOne">
                <h2 className='chromeExtensions__h2'>Staff Profile Generator - </h2>
                <Link className='chromeExtensions__Link' target="_blank" rel="noopener noreferrer" to={'https://github.com/SmileAndWaveBoyz/Staff-profile-extension'}>View on Git Hub</Link>
                <p className='chromeExtensions__par'>
                  I developed this for a care provider to generate PDF Staff Information documents to be sent to clients. 
                  The extension scrapes live CRM data to evaluate training records and dynamically calculate required DBS and Right to Work documentation.
                  This replaces a manual and time consuming process using Excel.
                  <br/><br/>
                  It also has built in templates that will change the layout depending on which client the document will be sent to,
                  and is even used to generate the staff information spreadsheet used by one of the companies biggest clients.
                </p>
              </div>
              <img className='chromeExtensions__screenShot' src="../assets/images/Staff-Profile.webp" alt="A screen shot of the staff profile generator" />
            </div>

            <div className="chromeExtensions__divider" data-aos="flip-left">
              <div className="chromeExtensions__divOne">
              <h2 className='chromeExtensions__h2'>CRM Improver - </h2>
              <Link className='chromeExtensions__Link' target="_blank" rel="noopener noreferrer" to={'https://github.com/SmileAndWaveBoyz/nathan-is-great'}>View on Git Hub</Link>
              <p className='chromeExtensions__par'>
                  <p className='chromeExtensions__par'>
                    Developed for a healthcare provider to streamline administrative workflows and eliminate human error by injecting custom automation directly into the company CRM.
                  </p>

                  <div>
                    <h4>For the Compliance Team</h4>
                    <ul className='chromeExtensions__parList'>
                      <li>
                        <strong>Add Mandatory Training Automation:</strong> Mandatory classroom training packages can contain over 20 separate courses, 
                        each requiring individual entry and unique expiration dates. 
                        This feature has replaced a tedious, error-prone 35 minute manual task with a 1 click automation that dynamically calculates expiration dates 
                        and imports all records in under two minutes.
                      </li>
                      <li>
                        <strong>Visual Expiration Indicators:</strong> Implemented dynamic colour coding (green, amber, red) for training records based 
                        on how soon they expire, enabling instant compliance monitoring at a glance.
                      </li>
                      <li>
                        <strong>Automated DBS Background Checks:</strong> Integrated a 'Check DBS' action button that performs live criminal history checks against the Disclosure and Barring Service database, replacing a manual process that previously required filling out 6 separate form inputs on an external site.
                      </li>
                      <li>
                        <strong>Automated NMC Registration Verification:</strong> Built a 'Check NMC' button that runs real-time verifications against the Nursing and Midwifery Council register to ensure staff nurses maintain active registration without practice restrictions.
                      </li>
                    </ul>
                  </div>

                  <div>
                    <h4>For the Rota Team</h4>
                    <ul>
                      <li>
                        <strong>Bulk Document Downloader:</strong> Added batch download capabilities to extract specific employee documentation directly into organised folders, ready for client delivery.
                      </li>
                    </ul>
                  </div>

                  <div>
                    <h4>For the Recruitment Team</h4>
                    <ul>
                      <li>
                        <strong>Email Generator:</strong> Added a button which generates an email to be sent to candidates listing all the documents and training that are still outstanding to become compliant. 
                      </li>
                    </ul>
                  </div>
                </p>
              </div>
              <img className='chromeExtensions__screenShot' src="../assets/images/Nathan-Is-Great.webp" alt="A screen shot of the staff profile generator" />
            </div>
          </div>
          
        </div>

      </main>
      {/* <AnimationContainer/> */}
    </>
  )
}

export default ChromeExtensions